import { createReducer } from '@reduxjs/toolkit';

import type { IShareModal } from './interfaces';
import * as actions from './actions';

const initialState: IShareModal = {
  open: false,
};

export default createReducer(initialState, (builder) => builder
  .addCase(actions.setOpenShare, (state, action) => {
    state.open = action.payload.open;
  }));
